import {  Component, Vue } from "vue-property-decorator"
import { financeRefundStatisticalData, financeRefundStatisticalDataExport } from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'

@Component({})
export default class OrderStatisticsData extends Vue {

  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  souCourseName = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false

  created() {
    this.getTableData()
  }

  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true
    const { allNum, financeRefundList } = await financeRefundStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
    })) as unknown as { allNum: number; financeRefundList: any[] }
    this.tableData = financeRefundList
    this.total = allNum
    this.tableLoading = false
  }

  // 导出
  async exportExcel() {
    this.exportButtonDisabled = true
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    await financeRefundStatisticalDataExport().finally(() => {
      this.exportButtonDisabled = false
    })
  }


  pageChange(page: number) {
    this.page = page
    this.getTableData()
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

}